import React, { useState } from "react";
import "./ConfirmDialog.css";

const ConfirmDialog = ({ show, token, onCancel, onConfirm, action }) => {
  const [input, setInput] = useState("");

  if (!show) return null;

  const handleConfirm = () => {
    onConfirm(input.trim());
    setInput("");
  };

  const handleCancel = () => {
    onCancel();
    setInput("");
  };

  return (
    <div className="confirm-dialog-overlay">
      <div className="confirm-dialog-box">
        <h3>Confirm Deletion</h3>
        <p>
          {action}, please type the following code to confirm:
        </p>
        <div className="token-box">{token}</div>
        <input
          type="text"
          placeholder="Type the code here"
          value={input}
          onChange={(e) => setInput(e.target.value)}
        />
        <div className="dialog-actions">
          <button className="cancel-btn" onClick={handleCancel}>
            Cancel
          </button>
          <button className="confirm-btn" onClick={handleConfirm}>
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;